import { gql } from '@/__generated__';

export const orderAddressDetailsFragment = gql(/* GraphQL */ `
  fragment OrderAddressDetails on OrderAddress {
    name
    streetLine
    streetDescription
    city
    postCode
    country
    phone
    addressId
  }
`);

export const orderCustomerDetailsFragment = gql(/* GraphQL */ `
  fragment OrderCustomerDetails on Customer {
    id
    pageId
    name
    email
    avatar
    createdAt
    updatedAt
    active
    reason
    addresses {
      id
      name
      streetLine
      streetDescription
      city
      postCode
      country
      phone
    }
    _count {
      orders
      addresses
    }
  }
`);

export const orderDetailsFragment = gql(/* GraphQL */ `
  fragment OrderDetails on Order {
    id
    package
    status
    total
    createdAt
    trackingNumber
    packedBy
    customer {
      id
      name
    }
    shippingMethod {
      id
      name
    }
    paymentMethod {
      id
      name
    }
    payments {
      id
      method
      amount
      status
      referenceId
      createdAt
      updatedAt
    }
  }
`);

export const orderLineDetailsFragment = gql(/* GraphQL */ `
  fragment OrderLineDetails on OrderLine {
    id
    type
    status
    code
    name
    description
    price
    productVariantId
    shippingMethodId
    paymentMethodId
  }
`);

export const orderCancellationDetailsFragment = gql(/* GraphQL */ `
  fragment OrderCancellationDetails on OrderLineCancellation {
    id
    lineCode
    lineName
    linePrice
    source
    reason
    cancelledAt
  }
`);
